import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import I18n from 'PMT/i18n/I18n';
import _ from 'lodash';

import { Modal } from 'react-bootstrap';

import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';
import ItemSuggestion from 'PMT/entities/menu/ItemSuggestion';

import SuggestionForm from './SuggestionForm';

export default class SuggestionFormModal extends Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    restaurantMenu: PropTypes.objectOf(RestaurantMenu).isRequired,
    itemSuggestion: PropTypes.objectOf(ItemSuggestion),
    onSubmit: PropTypes.func.isRequired,
  };

  renderBody() {
    return (
      <SuggestionForm
        restaurantMenu={this.props.restaurantMenu}
        itemSuggestion={this.props.itemSuggestion}
        onSubmit={this.props.onSubmit}
      />
    );
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.props.onHide}
      >
        <Modal.Header>
          <button
            type="button"
            className="close close-white"
            onClick={this.props.onHide}
          >
            <span aria-hidden="true">×</span>
          </button>
          <Modal.Title>
            {!_.isNull(this.props.itemSuggestion) ? I18n.tr('menu.suggestions.form.edit_suggestion') : I18n.tr('menu.suggestions.form.add_suggestion')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/menu/suggestions/suggestionForm/SuggestionFormModal.js